module.exports = __webpack_public_path__ + "img/folder24.f1c9f44f.svg";